// extracted by mini-css-extract-plugin
export default {"powerbiEmbed":"ReportPage_powerbiEmbed__zLwlz"};